// Libraries
import React from 'react';

// Supermove
import {Icon} from '@supermove/components';
import {gql} from '@supermove/graphql';
import {useToast} from '@supermove/hooks';
import {StageModel} from '@supermove/models';

// App
import ConfirmationModal from '@shared/design/components/Modal/SmallModal/ConfirmationModal';
import SuccessToast from '@shared/design/components/Toast/SuccessToast';
import ToggleStageIsArchivedForm from '@shared/modules/Project/forms/ToggleStageIsArchivedForm';
import useToggleStageIsArchivedMutation from '@shared/modules/Project/hooks/useToggleStageIsArchivedMutation';

const RestoreStageModal = ({
  stage,
  isOpen,
  handleClose,
  refetch,
}: {
  stage: StageModel;
  isOpen: boolean;
  handleClose: () => void;
  refetch: () => void;
}) => {
  const handleToggleArchivedSuccessToast = useToast({
    ToastComponent: SuccessToast,
    message: 'Sales stage restored.',
  });

  const {handleSubmit: handleToggleArchived} = useToggleStageIsArchivedMutation({
    form: ToggleStageIsArchivedForm.new({
      stageId: Number(stage.id),
      isArchived: false,
    }),
    onSuccess: () => {
      handleToggleArchivedSuccessToast.handleToast();
      handleClose();
      refetch();
    },
    onError: (errors) => console.log({errors}),
  });

  return (
    <ConfirmationModal
      icon={Icon.CirclePlus}
      isOpen={isOpen}
      title={`Restore '${stage.name}'?`}
      subtitle={`New leads can be assigned to this sales stage, but existing leads will remain unchanged.`}
      handlePressOutside={handleClose}
      primaryActionText={'Confirm'}
      handlePrimaryAction={handleToggleArchived}
      secondaryActionText={'Cancel'}
      handleSecondaryAction={handleClose}
    />
  );
};

RestoreStageModal.fragment = gql`
  fragment RestoreStageModal on Stage {
    id
    name
  }
`;

export default RestoreStageModal;
